export enum KnmErpActionsEnum {
  KNM_ERP_SET_INITIAL_FORM_VALUES = 'KNM_ERP_SET_INITIAL_FORM_VALUES',
  KNM_ERP_RESET_INITIAL_FORM_VALUES = 'KNM_ERP_RESET_INITIAL_FORM_VALUES',
}
